<template>
    <v-container>
        <v-layout row v-if="error">
            <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
        </v-layout>
        <app-loading v-if="loading"></app-loading>
        <v-layout v-else row>
                <v-container fluid>
                    <v-row dense>
                        <v-col
                                :cols="12"
                        >
                            <v-card :color="newSegmentColour">
                                <v-card-title class="white--text">
                                    <v-icon>add</v-icon>
                                    New Segment</v-card-title>
                                <v-card-text>
                                    <v-text-field
                                            v-model="segmentName"
                                            class="display-1"
                                    ></v-text-field>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn icon @click="changeColour"><v-icon>autorenew</v-icon></v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn :disabled="segmentNameValid" class="blue white--text" outlined @click="createSegment">
                                      create
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col
                                v-for="card in segments"
                                :key="card.created"
                                :cols="6"
                        >
                            <v-card :color="card.colour" @click="routeToSegment(card.id)">
                                <v-card-title v-text="card.name"></v-card-title>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn icon>
                                        <v-icon>mdi-bookmark</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>

                    </v-row>
                </v-container>

        </v-layout>
    </v-container>
</template>
<script>
    // import Avatar from "vue-avatar"
    import moment from "moment"
    import {collection, addDoc, onSnapshot} from "firebase/firestore";
    export default {
        // components: {
        //     Avatar
        // },
        props: ["phoneNumber", "uid"],
        data() {
            return {
                segmentName: "",
                newSegmentColour: undefined,
                segments: [],
            }
        },
        computed: {
            moment () {
                return (date) => {
                    let day = moment(date).format('ddd, MMM Do, hh:mm:ss A')
                    return day
                }
            },
            error () {
                return this.$store.getters.error
            },
            loading () {
                return this.$store.getters.loading
            },
            segmentNameValid () {
                if (this.segmentName !== "") {
                    return false
                } else return true
            }
        },
        created() {
          this.changeColour()
          let db = this.$store.state.db
          let segmentRef = collection(db, 'users', this.uid + '/provisionedNumbers/' + this.phoneNumber + '/segments')
          onSnapshot(segmentRef, res => {
                if(!res.empty){
                    let segments = []
                    res.forEach(doc => {
                        segments.push({...doc.data(), id: doc.id})
                    })
                    // console.log(segments)
                    this.segments = segments
                }
            })
        },
        methods: {
            routeToSegment (value)  {
              this.$router.push('/segments/'+ this.uid +'/'+ this.phoneNumber + '/' + value)
            },
            onDismissed() {
                this.$store.dispatch('clearError')
            },
            createSegment () {
              let db = this.$store.state.db
                let segmentRef = collection(db, 'users', this.uid + '/provisionedNumbers/' + this.phoneNumber + '/segments')
                let segmentObject = {
                    created: Date.now(),
                    name: this.segmentName,
                    colour: this.newSegmentColour
                }
                if (this.segmentName !== "") {
                  addDoc(segmentRef, segmentObject)
                    .then(res => {
                        this.$router.push('/segments/'+ this.uid +'/'+ this.phoneNumber + '/' + res.id)
                    })
                }
            },
            changeColour () {
                let randomColor = Math.floor(Math.random()*16777215).toString(16);
                this.newSegmentColour = "#" + randomColor
            }
        }
    }
</script>
